class Modal extends HTMLElement {
  constructor() {
    super();

    this.close = this.querySelector('.modal__close');
    this.overlay = this.querySelector('.modal__overlay');

    this.overlay.addEventListener("click", () => this.closeModal());
    this.addEventListener("keydown", event => this.handleEscapeKey(event));
    if (this.close) this.close.addEventListener("click", () => this.closeModal());

    subscribe(PUB_SUB_EVENTS.modalOpen, modal => this.openModal(modal));
  }

  handleEscapeKey(event) {
    if (event.key === "Escape") this.closeModal();
  }

  openModal(modal) {
    if (this !== modal) return;

    this.classList.add("modal--active");
    this.setAttribute("aria-hidden", "false");
    this.setAttribute("tabindex", "0");

    trapFocus(this);

    document.body.classList.add("overflow-hidden");
  }

  closeModal() {
    this.classList.remove("modal--active");
    this.setAttribute("aria-hidden", "true");
    this.setAttribute("tabindex", "-1");

    removeTrapFocus(this);

    document.body.classList.remove("overflow-hidden");
  }
}

class ModalTrigger extends HTMLElement {
  constructor() {
    super();

    this.modalTag = this.dataset.modalTag;

    if (!this.modalTag) return;

    this.modal = document.getElementById(this.modalTag);

    if (!this.modal) return;

    this.addListeners();
  }

  addListeners() {
    this.addEventListener("click", () => publish(PUB_SUB_EVENTS.modalOpen, this.modal));
    this.addEventListener("keydown", event => {
      if (event.key === "Enter" || event.key === "Space") {
        publish(PUB_SUB_EVENTS.modalOpen, this.modal);
      }
    });
  }
}

customElements.define("modal-component", Modal);
customElements.define("modal-trigger", ModalTrigger);
